import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "../data/content";
import { SectionHeading, Reveal, EASE } from "../lib/motion";
import { t } from "../i18n";

const FaqItem = ({ faq, open, onToggle, index }) => (
  <div className={`glass-card rounded-xl overflow-hidden transition-colors duration-300 ${open ? "border-gold/40" : ""}`} data-testid={`faq-item-${index}`}>
    <button
      onClick={onToggle}
      data-testid={`faq-question-${index}`}
      className="w-full flex items-center justify-between gap-4 px-6 sm:px-8 py-5 text-left"
      aria-expanded={open}
    >
      <span className="font-display font-semibold text-white text-sm sm:text-base">{t(`faq.items.${index}.q`, faq.q)}</span>
      <motion.span
        animate={{ rotate: open ? 45 : 0 }}
        transition={{ duration: 0.3, ease: EASE }}
        className={`shrink-0 flex h-8 w-8 items-center justify-center rounded-full border ${open ? "border-gold bg-gold/15 text-gold" : "border-white/15 text-slate-400"}`}
      >
        <Plus className="h-4 w-4" />
      </motion.span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.4, ease: EASE }}
        >
          <p className="px-6 sm:px-8 pb-6 text-sm text-slate-400 leading-relaxed" data-testid={`faq-answer-${index}`}>
            {t(`faq.items.${index}.a`, faq.a)}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

const FaqSection = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-32 bg-navy-deep">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow={t("faq.eyebrow")}
          title={t("faq.title")}
          description={t("faq.desc")}
          testid="faq-heading"
        />
        <Reveal className="space-y-4">
          {FAQS.map((f, i) => (
            <FaqItem key={i} faq={f} index={i} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default FaqSection;
